import React, { useState, useEffect } from 'react';
import { translate } from 'react-switch-lang';
import { ListingDatatable } from '../../_fragments';
import Form from './Form';
import { assetSubClassSchema as schema } from '../../_validationSchema';
import { assetSubClassAction as actions } from '../../_action/assetSubClass.action';
import { assetSubClass_model as model } from '../../_model';
import { assetSubClassConstants as constants } from '../../_constants';
import { assetClassConstants as class_constants } from '../../_constants';

import { useSelector } from 'react-redux';

const AssetSubClass = (props) => {
  const { t } = props;

  const header = { name: 'AssetSubClass', icon: 'cubes' };
  const reducer = useSelector((state) => state.assetSubClassOperation);
  const [item, setItem] = React.useState({});

  const filenameXML = 'asset-subclass';
  const menuCode = 'M_ASSET_SUBCLS';
  const columns = [
    { title: t('code'), field: 'Code' },
    { title: t('description'), field: 'Description' },
    { title: t('assetClass'), field: 'AssetClass' },
  ];
  let useService = () => {
    return [schema, actions, model, constants, class_constants];
  };
  const [open, setOpen] = useState(false);
  const [selectedCode, setSelected] = useState('');
  const [type, setFormType] = useState('');
  const [keyTrigger, setTrigger] = useState(false);
  useEffect(() => {
    if (open === false) {
      setFormType('');
      setTrigger(!keyTrigger);
    }
  }, [open]);
  useEffect(() => {
    if (reducer.getSuccess) {
      setItem(reducer.data.data.info);
    }
  }, [reducer]);

  return (
    <>
      <Form
        type={type}
        header={header}
        code={selectedCode}
        open={open}
        setClose={() => setOpen(false)}
        useService={useService}
        reducer={reducer}
        item={item}
      />
      <ListingDatatable
        key={keyTrigger}
        header={header}
        columns={columns}
        filenameXML={filenameXML}
        setSelected={setSelected}
        setFormOpen={setOpen}
        setFormType={setFormType}
        menuCode={menuCode}
      />
    </>
  );
};

export default translate(AssetSubClass);
